import { isMobileDevice } from "../../utils/getPlatformInfo";
import styles from "./index.module.scss";
import playBtn from "../../assets/images/playBtnn.png";
import { useContext, useEffect, useState, useMemo } from "react";

import RowsManager from "../../Managers/RowsManager";
import { useHistory, useLocation } from "react-router-dom";
import {
  HOME_HOT_TOPICS_CLICK,
  HOME_LATEST_SHOWS_CLICK,
} from "../../AppConstants/AnalyticsEventName";
import { AnalyticsContext } from "../../contexts/Analytics/AnalyticsContextProvider";

import HotTopicCard from "./HotTopicCard/HotTopicCard";
import {
  algoliaCustomEvents,
  AlgoliaEventType,
  algoliaIndices,
} from "../../AppConstants/AlgoliaSearchConstants";
import { Box, Shimmer } from "../ShimmerEffect";
import { ContentType2, VideoType } from "../../AppConstants/TypeConstants";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation } from "swiper";

// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import SeasonManager from "../../Managers/Video/seasons";
import { ROW_TYPE } from "../../AppConstants/Constants";
import { ConstantDataContext } from "../../contexts/ConstantContext/ConstantDataContextProvider";
import { HOME_PAGE_CLICK_EVENT } from "../../Clevertap/EventNames.ts";
import { getStandaloneVideoData } from "../../Clevertap/EventHandler.ts";

const breakpoints = {
  300: {
    slidesPerView: 2.8,
    spaceBetween: 15,
  },
  700: {
    slidesPerView: 3.3,
    spaceBetween: 6,
  },
  900: {
    slidesPerView: 4,
    spaceBetween: 15,
  },
  1024: {
    slidesPerView: 5,
    spaceBetween: 15,
  },
  1200: {
    slidesPerView: 5,
    spaceBetween: 15,
  },
  1400: {
    slidesPerView: 6.5,
    spaceBetween: 15,
  },
  1920: {
    slidesPerView: 7,
    spaceBetween: 15,
  },
};
const trendinRowBreakpoints = {
  300: {
    slidesPerView: 2.6,
    spaceBetween: 15,
  },
  700: {
    slidesPerView: 3.3,
    spaceBetween: 6,
  },
  900: {
    slidesPerView: 4,
    spaceBetween: 15,
  },
  1024: {
    slidesPerView: 4.5,
    spaceBetween: 15,
  },
  1200: {
    slidesPerView: 5.5,
    spaceBetween: 15,
  },
  1400: {
    slidesPerView: 6,
    spaceBetween: 15,
  },
  1920: {
    slidesPerView: 6,
    spaceBetween: 15,
  },
};
const hotTopicsBreakPoints = {
  300: {
    slidesPerView: 2,
    spaceBetween: 22,
  },
  700: {
    slidesPerView: 3,
    spaceBetween: 7,
  },
  900: {
    slidesPerView: 4,
    spaceBetween: 15,
  },
  1024: {
    slidesPerView: 3.6,
    spaceBetween: 15,
  },
  1100: {
    slidesPerView: 4.5,
    spaceBetween: 15,
  },
  1350: {
    slidesPerView: 5.5,
    spaceBetween: 15,
  },
  1400: {
    slidesPerView: 5,
    spaceBetween: 15,
  },
  1500: {
    slidesPerView: 5,
    spaceBetween: 15,
  },
  1920: {
    slidesPerView: 5,
    spaceBetween: 15,
  },
};

const getThumbnailURL = (rowName, item) => {
  let url = item?.thumbnailUrl;
  switch (rowName) {
    case ROW_TYPE.RECOMMENDED_ROW:
      url = item?.thumbnailUrlV1;
      break;
    case ROW_TYPE.CONTINUE_WATCHING:
      url = item?.thumbnailUrlV2;
      break;
    case ROW_TYPE.RECENTLY_ADDED:
      url = item?.thumbnailUrlV3;
      break;
    case ROW_TYPE.MOST_VIEWED_SHOWS:
      url = item?.thumbnailUrlV4;
      break;
    case ROW_TYPE.LATEST_SHOWS:
      url = item?.thumbPortraitUrl;
      break;
    case ROW_TYPE.TRENDING_SHOWS:
      url = item?.thumbPortraitUrl;
      break;
    default:
      url = item?.thumbnailUrl;
      break;
  }
  return url || item?.thumbnailUrl;
};

const fetchBasedOnSpeciality = [
  ROW_TYPE.TRENDING_SHOWS,
  ROW_TYPE.RECOMMENDED_ROW,
  ROW_TYPE.MOST_VIEWED_SHOWS,
];

function SeasonsWrapper({
  addEventAnalytics = () => {},
  rowName,
  tag = {},
  Header,
  allowHeader,
}) {
  const history = useHistory();
  const { addGAWithUserInfo, SearchEvent } = useContext(AnalyticsContext);
  const { handleSeasonModalOpen, selectedShow, setSelectedShow } =
    useContext(ConstantDataContext);
  const { showSearch, setShowSearch } = useContext(ConstantDataContext);

  const { pathname, search = "", hash = "", state } = useLocation();

  const [rowData, setRowData] = useState({ data: [], lastDocRef: null });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (rowName) {
      getData(true);
    }
  }, [rowName]);

  const getData = async (fetchMore = false) => {
    try {
      switch (rowName) {
        case ROW_TYPE.LATEST_SHOWS:
        case ROW_TYPE.TRENDING_SHOWS:
          // do not paginate data
          if (!fetchMore) {
            return;
          }
          let trendingShowsData = await SeasonManager._get.getTrendingSeries();
          setIsLoading(false);

          setRowData({
            data: trendingShowsData.data,
            lastDocRef: trendingShowsData.lastDocRef,
          });
          break;
        case ROW_TYPE.HOT_TOPICS_CARD:
          // do not paginate data
          if (!fetchMore) {
            return;
          }
          RowsManager._get.getShowsImages(rowName).then((response) => {
            if (response) {
              setRowData({
                data:
                  rowName === "hotTopicsCard"
                    ? response.data.filter((item) => item.enable)
                    : Object.values(response.data).length > 0 &&
                      Object.values(response.data).sort(
                        (a, b) => a.order - b.order
                      ),
                lastDocRef: null,
              });
            }
          });
          setIsLoading(false);
          break;

        case ROW_TYPE.RECOMMENDED_ROW:
          // do not paginate data
          if (!fetchMore) {
            return;
          }
          let recommendedData =
            await SeasonManager._get.fetchSeasonsByUserSpeciality({
              speciality: tag.speciality,
              ...rowData,
            });
            
          setIsLoading(false);
          setRowData({
            data: recommendedData.data,
            lastDocRef: recommendedData.lastDocRef,
          });

          break;
        case ROW_TYPE.CONTINUE_WATCHING:
          if (!fetchMore) {
            return;
          }
          let continueWatchingData =
            await SeasonManager._get.getContinueWatching({
              uid: tag.uid,
              ...rowData,
            });
          setIsLoading(false);

          setRowData({
            data: continueWatchingData.data,
            lastDocRef: continueWatchingData.lastDocRef,
          });
          break;
        case ROW_TYPE.RECENTLY_ADDED:
          let recentlyAddedData = await SeasonManager._get.recentlyAddedSeasons(
            {
              ...rowData,
            }
          );
          setIsLoading(false);

          setRowData({
            data: recentlyAddedData.data,
            lastDocRef: recentlyAddedData.lastDocRef,
          });
          break;
        case ROW_TYPE.MOST_VIEWED_SHOWS:
          // do not paginate data
          if (!fetchMore) {
            return;
          }
          let mostViewedData =
            await SeasonManager._get.fetchMostViewedSeasons();
          setIsLoading(false);

          setRowData({
            data: mostViewedData.data,
            lastDocRef: mostViewedData.lastDocRef,
          });
          break;

        default:
          setIsLoading(false);
          setRowData({ data: [], lastDocRef: null });
          break;
      }
    } catch (error) {
      setIsLoading(false);
      setRowData({ data: [], lastDocRef: null });
    }
  };

  const handleClick = (item) => {
    if (rowName === ROW_TYPE.HOT_TOPICS_CARD) {
      addGAWithUserInfo(HOME_HOT_TOPICS_CLICK, {
        eventId: item.title,
      });
      addEventAnalytics(HOME_PAGE_CLICK_EVENT, { "Content Title": item.title });

      // return history.push({
      //   pathname: "/search",
      //   search: `?search=${encodeURIComponent(item.title)}&${search.slice(
      //     1
      //   )}&customSearch=${true}`,
      // });
      history.push(`./?search=${encodeURIComponent(item.title)}`);
      setSelectedShow(item.title);
      setShowSearch(true);
    } else {
      addEventAnalytics(
        HOME_PAGE_CLICK_EVENT,
        getStandaloneVideoData({
          ...item,
          targetType:
            rowName === ROW_TYPE.TRENDING_SHOWS
              ? ContentType2.Series
              : rowName === ROW_TYPE.RECOMMENDED_ROW
              ? ContentType2.Season
              : "",
        })
      );
      if (
        rowName === ROW_TYPE.LATEST_SHOWS ||
        rowName === ROW_TYPE.TRENDING_SHOWS
      ) {
        // if (!item.clickable) {
        //   return;
        // }
        if (item.id) {
          SearchEvent(
            AlgoliaEventType.Click,
            algoliaIndices.videos,
            algoliaCustomEvents.normalClick,
            [item.id]
          );
          history.push({
            pathname: `/series/${item.id}`,
            search: search,
          });
        } else {
          redirectToVideoDetailPage(item.id);
        }
      } else {
        handleSeasonModalOpen(rowName, item);
      }
      if (rowName === ROW_TYPE.LATEST_SHOWS) {
        addEventAnalytics(HOME_PAGE_CLICK_EVENT, getStandaloneVideoData(item));
        addGAWithUserInfo(HOME_LATEST_SHOWS_CLICK, {
          eventId: item.id,
          ...item,
        });
      } else {
        addEventAnalytics(HOME_PAGE_CLICK_EVENT, getStandaloneVideoData(item));
        addGAWithUserInfo(`${rowName}_item_click`, {
          eventId: item.id,
          ...item,
        });
      }
    }
  };

  const redirectToVideoDetailPage = (id) => {
    return history.push({ pathname: `/video/${id}`, search: search });
  };

  const renderData = useMemo(() => {
    let _data = rowData.data;
    if (_data) {
      if (tag && tag.speciality && fetchBasedOnSpeciality.includes(rowName)) {
        _data = rowData.data.filter((doc) => {
          return doc?.speciality?.includes(tag.speciality.toLowerCase());
        });
      }
      return _data;
    }
  }, [tag, rowData.data]);

  return (
    <>
      {renderData?.length > 0 && allowHeader && Header()}
      <Shimmer
        loading={isLoading}
        loadingComponent={
          <div
            style={{
              padding: "0 6%",
            }}
            id={rowName}
          >
            <div
              style={{
                display: "flex",
                marginBottom: 50,
              }}
            >
              {!isMobileDevice ? (
                <>
                  <Box height={500} width={400} marginRight={30} />
                  <Box height={500} width={400} marginRight={30} />
                  <Box height={500} width={400} marginRight={30} />
                  <Box height={500} width={400} marginRight={30} />
                  <Box height={500} width={400} marginRight={30} />
                </>
              ) : (
                <>
                  <Box height={500} width={450} marginRight={30} />
                </>
              )}
            </div>
          </div>
        }
        renderComponent={
          <div className={styles.mainContainer}>
            {rowName === ROW_TYPE.HOT_TOPICS_CARD ? (
              <Swiper
                breakpoints={hotTopicsBreakPoints}
                navigation={!isMobileDevice}
                freeMode={true}
                modules={[FreeMode, Navigation]}
                speed={1000}
                className={styles.swiperContainer}
              >
                {rowData.data.map((item, index) => (
                  <SwiperSlide
                    className={styles["swiper-slide"]}
                    key={index}
                    onClick={item.clickable ? () => handleClick(item) : null}
                  >
                    <HotTopicCard item={item} key={index} />
                  </SwiperSlide>
                ))}
              </Swiper>
            ) : (
              <Swiper
                onReachEnd={(e) => {
                  if (
                    e.isEnd &&
                    !e.isBeginning &&
                    rowData.data &&
                    rowData.lastDocRef
                  ) {
                    getData();
                  }
                }}
                breakpoints={
                  rowName === ROW_TYPE.TRENDING_SHOWS
                    ? trendinRowBreakpoints
                    : breakpoints
                }
                navigation={!isMobileDevice}
                freeMode={true}
                modules={[FreeMode, Navigation]}
                speed={1000}
                className={styles.swiperContainer}
              >
                {renderData.map((item, index) => (
                  <SwiperSlide
                    className={styles["swiper-slide"]}
                    key={index}
                    onClick={() => handleClick(item)}
                  >
                    <div className={styles.item}>
                      <img src={getThumbnailURL(rowName, item)} alt="" />
                      {/* {rowName === ROW_TYPE.TRENDING_SHOWS && (
                      <img className={styles.playBtn} src={playBtn} alt="" />
                    )} */}
                      {rowName === ROW_TYPE.TRENDING_SHOWS &&
                        item.comingSoon && (
                          <div className={styles.comingSoon}>
                            Coming Soon...
                          </div>
                        )}
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </div>
        }
      />
    </>
  );
}

export default SeasonsWrapper;
